import { Uploader } from "uploader";
import { UploadButton } from "react-uploader";

// Get production API keys from Upload.io
const uploader = Uploader({
    apiKey: "free"
});

// Customize the file upload UI (see "customization"):
const options = { multi: false }

// Render the file upload button:
export const MyButtonComponent = () =>
    <UploadButton uploader={uploader}         // Required.
        options={options}           // Optional.
        onComplete={files => {      // Optional.
            if (files.length === 0) {
                console.log('No files selected.')
            } else {
                console.log('Files uploaded:');
                console.log(files.map(f => f.fileUrl));
            }
        }}>
        {({ onClick }) =>
            <button onClick={onClick}>
                Upload a file...
            </button>
        }
    </UploadButton>